import { createSlice } from '@reduxjs/toolkit';

import { aiApi } from '../service/ai';
import { AIState } from '../service/ai.interface';
import { RootState } from '../../../../../store';

const initialState: AIState = {
    default_prompt: '',
    first_message: '',
    prompt: '',
    shop_id: null,
    ai_assistant_enable: false,
    status: {
        isLoading: true,
        isSuccess: false,
    },
};

export const aiSlice = createSlice({
    name: 'aiProfile',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addMatcher(aiApi.endpoints.readAI.matchPending, state => {
                state.status.isLoading = true;
                state.status.isSuccess = false;
            })
            .addMatcher(
                aiApi.endpoints.readAI.matchFulfilled,
                (state, { payload }) => {
                    Object.assign(state, {
                        ...state,
                        ...payload,
                    });
                    state.status.isLoading = false;
                    state.status.isSuccess = true;
                }
            )
            .addMatcher(aiApi.endpoints.readAI.matchRejected, state => {
                state.status.isLoading = false;
                state.status.isSuccess = false;
            });
    },
});

export const selectAIState = (state: RootState): AIState => state.aiProfile;

export const aiReducer = aiSlice.reducer;
